import axios from "axios";
import { useEffect, useState } from "react";
const CrossUpArrow = `${process.env.REACT_APP_S3_URL}rightSlantblack.svg`;
const LeftArrowBlack = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.png`;
const RightArrowBlack = `${process.env.REACT_APP_S3_URL}rightArrowPink.png`;
const LeftArrowInActive = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.svg`;
const LeftArrowActive = `${process.env.REACT_APP_S3_URL}LeftArrowPink.svg`;
const RightArrowInActive = `${process.env.REACT_APP_S3_URL}RightArrowBlack.svg`;
const RightArrowActive = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;

const News = () => {
    const [newsPosts, setNewsPosts] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);
        axios.get(process.env.REACT_APP_BACKEND_URL + '/api/v1/news')
            .then(response => {
                console.log(response.data);
                setNewsPosts(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the news!', error);
                setError('Failed to load news. Please try again later.');
                setIsLoading(false);
            });
    }, []);

    const itemsPerPage = 6; // Number of jobs per page
    const totalPages = Math.ceil(newsPosts.length / itemsPerPage);
    const [currentPage, setCurrentPage] = useState(1);
    // Get jobs for the current page
    const currentJobs = newsPosts.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers for navigation
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToBlog = (url: any) => {
        window.open(url, '_blank');
    }
    
    return (
        <div>
            {isLoading ? (
                <div className="loading-state">Loading news...</div>
            ) : error ? (
                <div className="error-state">
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>Try Again</button>
                </div>
            ) : (
                <>
                <div className="header-section-blog">
                    <div>
                        <h1 className="title">
                        <span className="highlight">News Room</span>
                        </h1>
                    </div>
                    <div className="pagination-section-blog">
                        <img
                            style={{ cursor: 'pointer'}}
                            src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive}
                            alt="Left Arrow"
                            onClick={handlePreviousPage}
                        />
                        <span className="page-indicator">{currentPage}/{totalPages}</span>
                        <img
                            style={{ cursor: 'pointer'}}
                            src={currentPage === totalPages ? RightArrowInActive : RightArrowActive}
                            alt="Right Arrow"
                            onClick={handleNextPage}
                        />
                    </div>
                </div>

                <div className="posts-section">
                    {currentJobs.map((post: any, index: number) => (
                    <div
                    onClick={() => {goToBlog(post?.excerpt)}}
                    className="post-card" key={index}>
                        <img src={post?.thumbnail} alt={post?.header} className="post-image" />
                        <div className="post-content">
                        <p className="post-date">{post?.postedOn}</p>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent:'space-between', alignItems: 'center'}}>
                            <div>
                                <h2 style={{width:'85%'}} className="post-title">{post?.header}
                                </h2>
                            </div>
                            <div className="arrow-icon-blog">
                                <img src={CrossUpArrow} alt='Arrow' />
                            </div>
                        </div>
                        <p className="post-description">{post.description}</p>
                        </div> 
                    </div>
                    ))}
                </div>
                <div className="pagination-section-blog-mobile">
                    <img
                        style={{ cursor: 'pointer' }}
                        src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive}
                        alt="Left Arrow"
                        onClick={handlePreviousPage}
                    />
                    <span className="page-indicator">{currentPage}/{totalPages}</span>
                    <img
                        style={{ cursor: 'pointer'}}
                        src={currentPage === totalPages ? RightArrowInActive : RightArrowActive}
                        alt="Right Arrow"
                        onClick={handleNextPage}
                    />
                </div>
                </>
            )}
        </div>
    )
}

export default News;
